import * as z from 'zod';

import { brandQueryLinkerSchema } from '@/_pages/settings/brands/shared';
import { partnerQueryLinkerSchema } from '@/_pages/settings/partners/shared';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';

import { invoiceFormSchema } from '../schemas';
import { invoiceEmailDeliveryStatusSchema } from '../schemas/invoice-email-delivery-status-schema';

// invoiceFormSchema has refinements, and Zod v4 disallows .pick() directly on refined objects.
// Clone from `.shape` first to keep the same field definitions without refinement checks.
const invoiceFormObjectSchema = z.object(invoiceFormSchema.shape);

export const invoiceFilterSchema = invoiceFormObjectSchema
  .pick({
    brand: true,
    partner: true,
    invoice_number: true,
    invoice_date: true,
    account_receivables: true,
    status: true,
    execution_status: true,
    client: true,
    due_date: true,
  })
  .extend({
    brand: z.array(brandQueryLinkerSchema).nullish(),
    partner: z.array(partnerQueryLinkerSchema).nullish(),
    client: companyQueryLinkerSchema.nullish(),
    latest_email_history: z
      .object({
        delivery_status: invoiceEmailDeliveryStatusSchema.nullish(),
      })
      .nullish(),
  });

export type InvoiceFilterSchema = z.infer<typeof invoiceFilterSchema>;
